// Shared sort helper for CBAM Investment Sector tables.
// Alphabetical A→Z, with "Cash" and "Other" buckets pinned to the bottom.

const TRAILING = ["cash", "other"];

function rank(name: string): number {
  const n = (name || "").trim().toLowerCase();
  const idx = TRAILING.indexOf(n);
  return idx === -1 ? 0 : 1 + idx;
}

export function compareSectorNames(a: string, b: string): number {
  const ra = rank(a);
  const rb = rank(b);
  if (ra !== rb) return ra - rb;
  return (a || "").localeCompare(b || "", undefined, { sensitivity: "base" });
}

export function sortSectorNames<T extends string>(arr: readonly T[]): T[] {
  return [...arr].sort(compareSectorNames);
}

export function sortBySectorName<T>(arr: readonly T[], get: (item: T) => string): T[] {
  return [...arr].sort((a, b) => compareSectorNames(get(a), get(b)));
}
